import { httpClient } from './httpClient';
import type {
  AccountInfoResponse,
  AccountInfoUpdatePayload,
  AccountInfoUpdateResponse,
  AutoRefillsResponse,
  AutoRefillUpdatePayload,
  AutoRefillsUpdateResponse,
  CreditCardInfoResponse,
  CreditCardUpdatePayload,
  CreditCardUpdateResponse,
  GuidedValueResponse,
  GuidedValueUpdatePayload,
  GuidedValueUpdateResponse,
  NotificationsPayload,
  NotificationsResponse,
} from '../types/api';

const ACCOUNT_INFO_PATH = '/AccountInfo';
const CREDIT_CARD_INFO_V3_PATH = '/AccountInfo/CreditCardInfoV3';
const AUTO_REFILLS_PATH = '/AccountInfo/AutoRefills';
const NOTIFICATIONS_PATH = '/AccountInfo/Notifications';
const RESET_LOGIN_EMAIL_PATH = '/mfa/ResetLoginEmail/';
const GUIDED_VALUE_INFO_PATH = '/GetGuidedValueUserInfo';
const GUIDED_VALUE_UPDATE_PATH = '/UpdateGuidedValueUserInfo/';

export async function getAccountInfo(): Promise<AccountInfoResponse> {
  const response = await httpClient.get<AccountInfoResponse>(ACCOUNT_INFO_PATH);
  return response.data;
}

export async function putAccountInfo(
  payload: AccountInfoUpdatePayload
): Promise<AccountInfoUpdateResponse> {
  const response = await httpClient.put<AccountInfoUpdateResponse>(ACCOUNT_INFO_PATH, payload);
  return response.data;
}

export async function getCreditCardInfoV3(): Promise<CreditCardInfoResponse> {
  const response = await httpClient.get<CreditCardInfoResponse>(CREDIT_CARD_INFO_V3_PATH);
  return response.data;
}

export async function putCreditCardInfoV3(
  payload: CreditCardUpdatePayload
): Promise<CreditCardUpdateResponse> {
  const response = await httpClient.put<CreditCardUpdateResponse>(
    CREDIT_CARD_INFO_V3_PATH,
    payload
  );
  return response.data;
}

export async function getAutoRefills(linkToken: string): Promise<AutoRefillsResponse> {
  const response = await httpClient.get<AutoRefillsResponse>(`${AUTO_REFILLS_PATH}/${linkToken}`);
  return response.data;
}

export async function putAutoRefills(
  linkToken: string,
  payload: AutoRefillUpdatePayload
): Promise<AutoRefillsUpdateResponse> {
  const response = await httpClient.put<AutoRefillsUpdateResponse>(
    `${AUTO_REFILLS_PATH}/${linkToken}`,
    payload
  );
  return response.data;
}

export async function patchResetLoginEmail(payload: {
  OriginalEmailAddress: string;
  NewEmailAddress: string;
}): Promise<NotificationsResponse> {
  const response = await httpClient.patch<NotificationsResponse>(
    RESET_LOGIN_EMAIL_PATH,
    payload
  );
  return response.data;
}

export async function putNotifications(
  payload: NotificationsPayload
): Promise<NotificationsResponse> {
  const response = await httpClient.put<NotificationsResponse>(NOTIFICATIONS_PATH, payload);
  return response.data;
}

export async function getGuidedValueUserInfo(memberId: string): Promise<GuidedValueResponse> {
  const response = await httpClient.get<GuidedValueResponse>(
    `${GUIDED_VALUE_INFO_PATH}?lakerId=${encodeURIComponent(memberId)}`
  );
  return response.data;
}

export async function postGuidedValue(
  payload: GuidedValueUpdatePayload
): Promise<GuidedValueUpdateResponse> {
  const response = await httpClient.post<GuidedValueUpdateResponse>(
    GUIDED_VALUE_UPDATE_PATH,
    payload
  );
  return response.data;
}
